export const getPlayerText = state => state.serverMenuReducer.texts.player
export const getPlayersText = state => state.serverMenuReducer.texts.players
export const getTestServerText = state => state.serverMenuReducer.texts.testServer
// export const getTestServerWarningText = state => state.testServerWarning
// export const getOnTestServerText = state => state.onTestServer



// WEBPACK FOOTER //
// ./src/features/ServerMenu/data/texts/selectors.js